
<template>
  <el-drawer append-to-body size='1062px' :show-close="false" :with-header="false" @open="doRobotHide(true)" :visible="visible" :destroy-on-close="true" @update:visible="changeShow"
    @closed="doRobotHide(false),closedDialog()">
    <div class="drawerWrap clearfix">
      <enterprise :companyStatus="companyStatus"></enterprise>
      <div :class="['number_box', 'fx-c',(NODE_ENV == 'erp' || NODE_ENV == 'erp-prod')?'erpNumber_box':'']" v-loading="waiting">
        <div class="fixation fx-none" style="background: #fff;">
          <div class='fiexWrap'>
            <div class="box_top">
              <h5>联系方式</h5>
              <el-popover placement="top-start" popper-class="box_top_popClass" width="200" trigger="hover" content="所有信息均来自互联网公开数据，如您认为有侵犯到您的个人信息或隐私，请联系客服进行处理。">
                <!-- <span slot="reference"> 
                  <img class="wen" src="@/assets/newicons/ik01.png" alt="">  
                </span> -->
                <img slot="reference" class="wen" src="@/assets/newicons/ik01.png" alt="">
              </el-popover>
            </div>
            <div class="box_tabs">
              <span v-for="(item,index) in numberData" :key="index" :class="{'current': showIndex === index}" @click="selectTabHead(index)">{{item.title}}({{item.total || 0}})</span>
            </div>
          </div>
        </div>
        <template v-if="companyStatus.lockStatus">
          <div class="box_content fx-full fx-c" v-for="(nowShowPhoneList,i) in numberData" :key="i" v-show="i==showIndex">
            <template v-if="i==showIndex && companyStatus.lockStatus">
              <template v-if="NODE_ENV !== 'erp-prod' && NODE_ENV !== 'erp'">
                <div class="box_content_bot fx fx-none" v-if="nowShowPhoneList.total">
                  <el-checkbox :disabled="!allowGet" v-model="nowShowPhoneList.checkedAll" :indeterminate="nowShowPhoneList.indeterminate" @change="checkedAllChange">全选</el-checkbox>
                  <div class="fx-full ml-8">
                    <div v-if="nowShowPhoneList.list.filter(e=>e.active).length">已选中{{nowShowPhoneList.list.filter(e=>e.active).length}}个</div>
                  </div>
                  <el-button class="fr" :class="{'noAllowClick':noAllowClick}" type="dialog-cancel" w80 size="small" :disabled="!allowGet" @click="getAll">领取线索</el-button>
                </div>
              </template>
              <el-scrollbar class="fx-full" ref="scrollbar">
                <div v-if="!nowShowPhoneList.total" class="emptyBox">
                  <div>
                    <div>
                      <img :src="emptyBox" alt="" srcset="">
                    </div>
                    <p>暂未查找到</p>
                  </div>
                </div>
                <ul class="box_content_list" v-else v-infinite-scroll="load" infinite-scroll-disabled="disabled">
                  <li v-for="(item,index) in nowShowPhoneList.list" :key="index" :class="[{'active': item.active, pointer: allowGet}]" @click="selectThis(item,$event)">

                    <div class="list_inside">
                      <!-- 已删除 -->
                      <img style="width:60px;height:22px;position: absolute;right: 0;top: 0;" v-if="item.isDel == 1" src="@/assets/newicons/del11.png" alt="">
                      <!-- 已转化 -->
                      <div class="already-received" v-if="item.isTurnClue && item.isDel != 1"><img src="@/assets/newicons/ylingqu.png" alt=""></div>
                      <!-- 手机 -->
                      <p :class="['cls001','telCls001']">{{item.type | filterType}}：<i class="blodd">{{item.content || '--'}}</i>
                        <span class="telCode" v-if="item.content && !item.content.includes('*')" @click.stop="copyName(item,index)"><i class="el-icon-document-copy">复制</i></span>
                      </p>
                      <div class="cls001" style="display:flex;align-items: center;justify-content: space-between;">
                        <span>姓名：<i>{{item.contactName || '--'}}</i></span>

                        <!-- <span class="doubt" v-if="item.suspected">疑似代理记账</span> -->

                        <!-- 1：正常	2：异常	3：未知	4:接通率高	5：疑似代理记账	6:号码准确 -->
                        <p class="clearfix">
                          <!-- 疑似代理记账 -->
                          <!-- buyaole -->
                          <el-tag type="info" size="small" v-if="item.numStatus == 5" :class="['tag'+item.numStatus]">{{ getStatusTitle(item.numStatus) }}</el-tag>
                          <!-- 正常，异常 -->
                          <el-popover v-if="![3,5].includes(item.numStatus)" placement="bottom" :disabled="!getText(item.numStatus)" trigger="hover" popper-class="popShow"
                            :content="getText(item.numStatus)">
                            <el-tag :type="{1:'success', 2:'info' }[item.numStatus] || 'info'"
                              :class="['tag-min',({1:'success', 2:'info', 4:'tag4', 6:'tag6' }[item.numStatus] || 'info'), 'tag'+item.numStatus]" size="small"
                              slot="reference">{{getStatusTitle(item.numStatus)}}</el-tag>
                          </el-popover>

                          <!-- 未知 -->
                          <el-popover v-if="item.numStatus == 3 && (item.type != 1 ? true : (item.udCaller && item.telOperator))" placement="bottom" trigger="hover" popper-class="popShow"
                            :content="getText(item.numStatus)">
                            <el-tag :type="'info'" :class="['tag-min','info', 'tag3']" size="small" slot="reference">{{getStatusTitle(item.numStatus)}}</el-tag>
                          </el-popover>

                        </p>
                      </div>

                      <div class="cls001" v-if="item.udCaller">
                        <span>归属地：<i>{{item.udCaller || '--'}}</i></span>
                      </div>
                      <div class="cls001" v-if="item.telOperator">
                        <span>运营商：<i>{{item.telOperator || '--'}}</i></span>
                      </div>

                      <p :class="['setP', 'fx-s-center', `setP-${item.type}`,'cls001',(!item.platformUse && !item.companyUse)?'setPNum':'']" style="line-height: 17px;    height: 17px;">
                        <span class="fx-none" style="vertical-align: middle;">来源：</span>
                        <span class="fx-full fx" style="width: 0;" v-if="item.count === 1">
                          <a class="underline fontSize hover sl" rel="noopener noreferrer" style="font-size:13px;color:rgba(66, 134, 245, 1) !important;text-decoration:underline;"
                            v-if="item.sources&&item.sources[0].sourceHref" :title="item.sources[0].source" :href="item.sources[0].sourceHref" target="about" @click.stop>{{item.sources[0].source}}</a>
                          <span v-else class="fontSize sl" :title="item.sources[0].source" style="font-size:13px;color: #333333;">{{item.sources[0].source}}</span>
                        </span>
                        <template v-if="item.count>1 && item.sources">
                          <el-popover placement="bottom-star" class="fx-full" width="100" trigger="hover" popper-class="popper-sources">
                            <div v-for="(s,index) in item.sources" :key="index">
                              <a class="underline source hover" rel="noopener noreferrer" v-if="s.sourceHref" :href="s.sourceHref" :title="s.source" target="about" @click.stop><img :src="quan" alt=""
                                  srcset="">{{s.source}}</a>
                              <span v-else @click.stop :title="s.source" class="nohands source"><img :src="quan" alt="" srcset="">{{s.source}}</span>
                            </div>
                            <span v-show="item.count>1" class="fontSize noActive" slot="reference"><span class="sTxt">{{item.sources[0].source}}</span><i class="sNum">({{item.count}})</i></span>
                          </el-popover>
                        </template>
                        <el-popover v-if="item.type==1" v-model="item.visible" placement="bottom-end" class="uili fx-none" width="165" trigger="click" popper-class="contactPopper">
                          <div v-loading="feedBackWait" class="phone-fakk">
                            <div class="check-list-warp">
                              <el-checkbox-group v-model="checkList">
                                <el-checkbox v-for="(label,index) in numberFeedBack" :key="index" :label="label"></el-checkbox>
                              </el-checkbox-group>
                            </div>
                            <el-button class="sureFeedBack llll" :loading="item.feedBackLoading" @click="sureFeedBack(item)">确认</el-button>
                          </div>
                          <span style="color:rgba(66, 134, 245, 1)" class="hover noActive pointer" @click.stop="getFeedbackDetail(item)" slot="reference">号码反馈</span>
                        </el-popover>
                      </p>

                      <!-- 号码使用次数 -->
                      <p class="cls001 usageNum" v-if="item.platformUse">近7日全网使用<span style="color:#5088FF">（{{item.platformUse}}）</span>次</p>
                      <p class="cls001 usageNum" v-if="item.companyUse">近7日我司使用<span style="color:#5088FF">（{{item.companyUse}}）</span>次</p>

                      <!-- <div class="tags-new01" style="margin-top:10px" v-if="(item.numStatus == 3 && item.type == 1) && (!item.udCaller || !item.telOperator || item.isKeyContact == 1)"> -->
                      <div class="tags-new01" style="margin-top:10px" v-if="item.type == 1 &&(!item.udCaller || !item.telOperator || item.isKeyContact == 1 ||item.tjIcon )">
                        <!-- 异常逻辑不要了 -->
                        <!-- <span class="doubt yic" v-if="!item.udCaller || !item.telOperator" style="margin-left:8px">疑似异常</span> -->
                        <span class="doubt gjr" v-if="item.isKeyContact == 1">疑似关键联系人</span>
                        <!-- 推荐ICON -->
                        <img v-if="item.tjIcon" src="@/assets/net-recomment.svg" class="netRecommend">
                      </div>

                      <span class="good" v-if="item.isRecommend"><img src="../../assets/good.svg">推荐</span>
                      <img class="checked" v-if="NODE_ENV !== 'erp' && NODE_ENV !== 'erp-prod'" style="width:28px;height:23px" src="@/assets/newicons/io01.png" alt="">

                    </div>
                    <!-- erp领取 -->
                    <div class="erpGet" v-if="!item.isTurnClue && (NODE_ENV == 'erp' || NODE_ENV == 'erp-prod')">
                      <el-button type="text" :disabled="!allowGet" @click.stop="addCrm(item,$event)">添加到CRM</el-button>
                    </div>
                  </li>
                  <p v-if="waiting && nowShowPhoneList.total" class="textAline">加载中...</p>
                  <p v-if="noMore && nowShowPhoneList.total" class="textAline">- 没有更多了 -</p>
                </ul>
              </el-scrollbar>
            </template>
          </div>
        </template>
        <div class="hiddenImg fx-full" v-else>
          <img src="@/assets/hidden.png" srcset="">
          <div class="looknumber">
            <p class="mb-20">获取更多联系方式</p>
            <el-button type="primary" size="small" v-interestExpire @click="unlockNow">立即解锁</el-button>
          </div>
        </div>
      </div>
    </div>
    <erp-get-dialog ref="erpGetDialog" @submitCrmFormData="getCrmFormData" :erpGetFlag="erpGetStatusFlag" :erpbackTip="erpGetbackTip"></erp-get-dialog>
  </el-drawer>
</template>

<script>
import enterprise from '@/views/clue/page/enterpriseNew'
import quan from '@/assets/quan.svg'
import emptyBox from '@/assets/emptyBox.svg'
import { feedback, feedbackDetail, contactSubmit, testPoint } from '@/views/clue/api/newClueApi'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { X_BLOCK, X_PRODUCT, X_HIDE } from '@/utils/iframeUtils'
const getPwdPhoneNumFunc = (e, i) => {
  if (i > 2 && i < 7) { return '*' }
  return e
}
import ErpGetDialog from '@/components/erpGetDialog'
import popupMixin from '@/mixins/popup-mixin'
import lockNumber from './../../views/clue/mixins/lockNumber.js'
export default {
  name: 'viewNumber',
  mixins: [popupMixin, lockNumber],
  components: {
    enterprise,
    ErpGetDialog
  },
  props: {
    companyStatus: {
      type: Object,
      default: () => ({ contactCount: {} })
    },
    type: {
      type: Number
    },
    unlockMark: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      noAllowClick: false,
      quan,
      emptyBox,
      direction: 'rtl',
      waiting: false,
      // numberData: [
      //   { title: '手机', list: [], total: 0 },
      //   { title: '固话', list: [], total: 0 },
      //   { title: '邮箱', list: [], total: 0 },
      //   { title: '全部', list: [], total: 0 }
      // ],
      showIndex: 0,

      // 反馈
      numberFeedBack: ['无效号码', '停机', '无人接听', '非该工时人员', '已离职', '其他'],
      checkList: [],
      feedBackWait: false,
      // 抽屉浮动
      position: false,
      NODE_ENV: '',
      windowProductObj: { 'scrmqw': 'SCRM企微', 'scrmzy': 'SCRM专业' },
      erpGetStatusFlag: 0,//是否是erp领取 弹出信息
      erpGetbackTip: '',//erp领取返回的接口提示
      erpFormParam: {},//表单数据
      choiceContactObj: {},//选中信息内容
      checkedAll: false,
    }
  },
  computed: {
    ...mapState({
      allowGet: state => state.user.hasCrmEquity,
      staffInfo: state => state.user.staffInfo
    }),
    phoneNum() {
      return item => {
        if ((process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') && item.content && item.isTurnClue) {
          const content = JSON.parse(JSON.stringify(item.content))
          return content.split('').map(getPwdPhoneNumFunc).join('')
        } else {
          return item.content
        }
      }
    },
    companyName() {
      return this.companyStatus.companyName
    },

    noMore() {
      return this.numberData[this.showIndex].total <= this.numberData[this.showIndex].list.length
    },
    disabled() {
      return this.waiting || this.noMore
    }
  },
  filters: {
    filterType(val) {
      let str
      switch (val) {
        case 1:
          str = '手机'
          break
        case 2:
          str = '固话'
          break
        case 3:
          str = '邮箱'
          break
      }
      return str
    }
  },
  mounted() {
    this.NODE_ENV = process.env.NODE_ENV
    this.getContactCount()
  },
  methods: {
    checkedAllChange(boolean) {
      this.numberData[this.showIndex].list.forEach(e => {
        e.active = boolean
      })
      this.numberData[this.showIndex].indeterminate = false
    },
    refreshData() {
      const classify = this.numberData[this.showIndex]
      classify.indeterminate = false
      classify.checkedAll = false
      classify.pageNum = 1
      classify.list = []
    },
    async firstLoadUnlock() {
      if (!this.showIndex && !this.companyStatus.unlock && this.companyStatus.lockStatus) {
        await this.getContactList(this.showIndex)
        this.$emit('unlock-change')
      }
    },
    async load() {
      await this.getContactList(this.showIndex)
      !this.companyStatus.unlock && this.$emit('unlock-change')
      this.numberData[this.showIndex].checkedAll = false
      this.setIndeterminate()
    },
    addCrm(item, e) {
      this.erpGetStatusFlag = 0
      this.erpGetbackTip = ''
      this.$refs.erpGetDialog.iniFun(item)
      this.choiceContactObj = item
    },
    // 复制公式ming
    copyName(row, index) {
      let val = row.content
      var textBox = document.createElement('input')
      textBox.value = val
      document.body.appendChild(textBox)
      textBox.select()
      document.execCommand('Copy')
      textBox.className = 'textBox'
      textBox.style.display = 'none'
      // this.$message.success('复制成功')
      this.$message({ type: 'success', message: '复制成功', duration: 2000 });
      document.body.removeChild(textBox)
      // 埋点
      let productName = ''
      if (window[X_PRODUCT]) {
        productName = windowProductObj[window[X_PRODUCT]]
      } else {
        if (window[X_BLOCK]) {
          productName = 'SCRM企微'
        } else {
          if (window[X_HIDE]) {
            productName = 'SCRM专业'
          } else {
            productName = (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') ? 'ERP-臻寻客' : 'T云-臻寻客'
          }
        }
      }

      let paramsM = {
        eventType: 'contact_copy',//事件类型
        productName: productName,//产品线名称
        pageSource: '详情页',
        type: this.showIndex == 3 ? 4 : row.type,
        contactRank: parseInt(index + 1),
        // contactInfo:this.showIndex == 3?'全部':(row.type == 1?'手机号':(row.type == 2?'固话':'邮箱'))
        contactInfo: row.content,
        hid: row.hid
      }
      testPoint(paramsM).then(res => {

      }).catch(err => {

      })
    },
    // TODO
    doRobotHide(flag) {
      if (!flag) {
        this.$emit('getBack')
      }
      this.$store.commit('SET_ROBOT_HIDE', flag)
    },
    getStatusTitle(status) {
      return ['', '正常', '异常', '未知', '接通率高', '疑似代理记账', '号码准确'][status] || '未知'
    },
    getStyle(status) {
      if (status == 1 || status == 5) {
        return 'tagsOther'
      } else {
        return 'tagsUnknown'
      }
    },
    async unlockNow() {
      // 是否是演示账号
      if (this.staffInfo.demonstrationTag == 1) {
        this.$message({ message: '演示账号，无法使用此功能', type: 'error' });
        return false
      }
      await this.getContactList()
      this.$emit('unlock-change')
    },
    getText(status) {
      if (status == 1) {
        return '号码检测结果：正常'
      } else if (status == 2) {
        return '号码检测结果：疑似空号/停机/不存在'
      } else if (![4, 6].includes(status)) {
        return '号码检测结果 ：未检测/沉默号'
      }
    },
    getCrmFormData(data) {
      this.erpFormParam = data
      this.erpGetAll(this.choiceContactObj)
    },
    async reqContactSubmit(list) {
      const arr = list.filter(e => e.isTurnClue === 0 || JSON.stringify(e.isTurnClue) === 'null')
      if (!arr.length) {
        this.$message.warning('已经领取过了')
        return
      }
      const params = {
        contactInfoList: [{
          companyName: arr[0].companyName,
          hid: arr[0].hid,
          contacts: arr.map(e => {
            return {
              sources: JSON.stringify(e.sources),
              contactInfo: e.contactInfo,
              contactName: e.contactName,
              type: e.type,
              isTurnClue: e.isTurnClue,
              ...this.erpFormParam,
            }
          })
        }]
      }
      try {
        //  this.$emit('getLoading',true)
        this.noAllowClick = true
        const { code, message } = await contactSubmit(params)
        if (code === 200) {
          this.$message.success('领取成功')

          // TODO 其他环境验证
          // this.refreshList()
          // this.getContactList(this.showIndex)
          const classify = this.numberData[this.showIndex]
          classify.indeterminate = false
          classify.checkedAll = false
          classify.list.forEach(e => {
            if (e.active) {
              e.isTurnClue = 1
              e.active = false
            }
          })


          // TODO
          // this.$emit('refreshList')
          // this.$parent.contactList()  //刷新抽屉转线信息

          // TODO
          // if (this.unlockMark) {
          //   this.$parent.$parent.unlockList() //刷新解锁列表信息
          // }
          this.erpGetStatusFlag = 1
          this.erpGetbackTip = message
        }
        this.noAllowClick = false
      } catch (e) {
        if (process.env.NODE_ENV == 'erp-prod' || process.env.NODE_ENV == 'erp') {
          this.$parent.contactList()  //刷新抽屉转线信息
        }
        this.noAllowClick = false
        this.erpGetStatusFlag = 2
        this.erpGetbackTip = e.data.message
      }
    },

    clearHistory() {
      this.showIndex = 0
    },
    erpGetAll(obj) {
      let arr = []
      if (this.NODE_ENV == 'erp' || this.NODE_ENV == 'erp-prod') {
        arr.push(obj)
      }
      if (arr.length) {
        this.reqContactSubmit(arr)
      } else {
        this.$message.warning('至少选择一个线索')
      }
    },
    getAll() {
      const selected = this.numberData[this.showIndex].list.filter(e => e.active)
      if (selected.length) {
        this.reqContactSubmit(selected)
      } else {
        this.$message.warning('至少选择一个线索')
      }
    },
    selectThis(item, e) {
      if (this.NODE_ENV == 'erp' || this.NODE_ENV == 'erp-prod') return
      if (item.isDel == 1) return
      if (!this.allowGet) return
      if (!e.target.className.includes('noActive')) {
        if (item.active) {
          item.active = !item.active
        } else {
          this.$set(item, 'active', true)
        }
      } this.setIndeterminate()
    },
    setIndeterminate() {
      this.numberData[this.showIndex].indeterminate = this.numberData[this.showIndex].list.some(e => e.active) && this.numberData[this.showIndex].list.some(e => !e.active)
    },
    selectTabHead(index) {
      this.showIndex = index
    },

    togglePop(item) {
      if (item.visible) {
        this.$set(item, 'visible', false)
        // item.visible = !item.visible
      }
    },
    async getFeedbackDetail(item) {
      this.numberData.forEach(v => {
        (v.list || []).forEach(vv => {
          if (vv.content != item.content) {
            this.togglePop(vv)
          }
        })
      })
      this.feedBackWait = true
      this.checkList = []
      const res = await feedbackDetail({ hid: this.companyStatus.hid, contactType: item.type, contactContent: item.contactInfo })
      if (res.data) {
        this.checkList = res.data?.feedbackContent?.split(',') || []
      }
      this.feedBackWait = false
    },
    async sureFeedBack(item) {
      if (this.checkList.length) {
        this.$set(item, 'feedBackLoading', true)
        try {
          await feedback({ hid: this.companyStatus.hid, contactType: item.type, contactContent: item.contactInfo, feedbackContent: this.checkList.join(',') })
          this.$message.success('反馈成功')
          this.togglePop(item)
        } catch (e) {
          console.log(e)
        } finally {
          this.$set(item, 'feedBackLoading', false)
        }

      } else {
        this.$message.warning('至少选择一项')
      }
    }
  }
}
</script>
<style>
.popShow {
  padding: 10px;
  font-size: 12px;
  border: 1px solid #ddd;
}
</style>
<style lang="scss">
.box_top_popClass {
  font-size: 12px;
  padding: 12px 16px;
  justify-content: space-between;
}
.contactPopper {
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
}
</style>
<style lang='scss' scoped>
.hiddenImg {
  position: relative;
  background-color: #fff;
  > img {
    width: 100%;
    height: 100%;
  }
  .looknumber {
    position: absolute;
    top: 210px;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }
}
.box_content_bot {
  padding: 10px 24px;
  line-height: 30px;
}
.popClass {
  font-size: 12px;
}
.closeBtn {
  float: left;
  width: 30px;
  height: 100%;
  background-color: #fff;
}
.drawerWrap {
  // overflow: hidden;
  background: rgb(241, 242, 244);
  .main {
    float: left;
    width: calc(100% - 346px);
    margin: 15px;
    margin-right: 0;
    height: 100vh;
    margin-top: 0;
    margin-bottom: 0;
    padding: 15px 0;
  }
  .number_box {
    float: right;
    width: 300px;
    // background: #fff;
    height: 100vh;
    margin: 15px;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding: 15px 0;
    // overflow: auto;
    // position: absolute;
    // z-index: 25;
    .fixation {
      // height: 142px;
      position: relative;
      .fiexWrap {
        width: 300px;
        background-color: #fff;
        // position: fixed;
        // box-shadow: 0 2px 5px 0px rgba(0, 0, 0, 0.1);
        z-index: 11;
        .box_top {
          padding: 0 24px;
          padding-top: 17px;
          padding-bottom: 24px;
          line-height: 21px;
          // border-bottom: 1px solid #f2f2f2;
          display: flex;
          // justify-content: space-between;
          > h5 {
            font-weight: bold;
            color: #333333;
            font-size: 15px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          > span {
            // font-size: 12px;
            // padding: 1px 5px;
            // // background-color: #ebf0fe;
            // color: #4f7afd;
            // display: block;
            // height: 20px;
            // line-height: 20px;
            // border-radius: 4px;
            // margin-top: 15px;
            // text-overflow: ellipsis;
            // overflow: hidden;
            // white-space: nowrap;
          }
          .wen {
            width: 16px;
            height: 16px;
            margin-left: 8px;
            margin-top: -3px;
            cursor: pointer;
          }
        }
        .box_tabs {
          border-bottom: 1px solid rgba(151, 151, 151, 0.24);
          // text-align: center;
          padding: 0 24px 8px 24px;
          display: flex;
          justify-content: space-between;
          > span {
            // width: calc(25%);
            display: inline-block;
            color: #333333;
            font-weight: bold;
            line-height: 20px;
            cursor: pointer;
            &:hover {
              color: rgba(80, 136, 255, 1);
            }
          }
          .current {
            color: rgba(80, 136, 255, 1);
          }
        }
      }
    }

    .box_content {
      padding: 0 0 10px;
      position: relative;
      height: calc(100% - 142px);
      background: #fff;
      .box_content_list {
        padding-right: 24px;
        padding-left: 24px;
        box-sizing: border-box;
      }
      .emptyBox {
        width: 100%;
        margin: 200px auto;
        text-align: center;
        img {
          width: 64px;
        }
        p {
          color: #aaa;
        }
      }

      .box_content_list {
        li + li {
          margin-top: 12px;
        }
      }
      .box_content_list li {
        border: 1px solid #ffffff;
        padding: 25px 16px 19px;
        // margin-bottom: 25px;
        position: relative;
        border-radius: 4px;
        // max-height: 114px;
        background: #f5f6f8;
        .isreceiver {
          position: absolute;
          right: 10px;
          top: 0;
          color: #fff;
          font-size: 12px;
          background: #dc8b22;
          padding: 0 5px;
          border-radius: 0 0 4px 4px;
        }
        .already-received {
          position: absolute;
          right: 0;
          top: 0;
          width: 60px;
          height: 21px;
          img {
            width: 100%;
          }
          // background-size: cover;
          // background-position: center;
          // text-align: center;
          // color: #ffffff;
          // font-size: 12px;
          // line-height: 21px;
        }
        p {
          font-size: 12px;

          &.setP {
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
          &.setP-1 .sTxt {
            max-width: 100px !important;
          }
          > a {
            margin-right: 10px;
          }
          i {
            font-weight: 500;
            font-size: 12px;
            color: #333;
          }
          .tags {
            border-radius: 4px;
            background-color: skyblue;
            padding: 2px 5px;
            color: #fff;
            font-size: 12px;
          }
          .tagsOther {
            border-radius: 2px;
            background-color: #4cbc9a;
            padding: 2px 5px;
            color: #fff;
            font-size: 12px;
          }
          .tagsUnknown {
            border-radius: 2px;
            background-color: #ddd;
            padding: 2px 5px;
            color: #a09e9e;
            font-size: 12px;
          }
          .nohands {
            cursor: initial;
          }
          .fontSize {
            font-size: 13px;
            color: #333333;
            .sNum {
              font-size: 13px;
              color: #4286f5;
            }
            .sTxt {
              max-width: 145px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              display: inline-block;
              vertical-align: middle;
            }
          }
          .hover:hover {
            color: #dc8b22 !important;
          }
          .source {
            font-size: 12px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
            width: 100%;
            line-height: 24px;
            > img {
              vertical-align: initial;
              margin-right: 3px;
            }
          }
        }
        .checked {
          display: none;
        }
        .good {
          background-color: #f59a23;
          border-radius: 0 0 4px 4px;
          font-size: 12px;
          color: #fff;
          padding: 1px 5px;
          position: absolute;
          top: 0;
          right: 10px;

          > img {
            width: 10px;
            vertical-align: unset;
          }
        }
        .cls001 {
          font-size: 13px;
          color: rgba(51, 51, 51, 0.5);
          line-height: 20px;
          margin-bottom: 10px;
          i {
            color: rgba(51, 51, 51, 1);
          }
          .blodd {
            font-size: 15px;
            font-weight: bold;
            color: #333333;
          }
          &.usageNum {
            margin-bottom: 0px;
          }
          &.setPNum {
            margin-bottom: 0;
          }
        }
        .tags-new01 {
          display: inline-block;
          width: 100%;
          text-align: right;
        }
        .doubt,
        .tag5 {
          width: 88px;
          height: 24px;
          background: rgba(147, 130, 255, 0.15);
          border-radius: 2px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(147, 130, 255, 1);
          line-height: 17px;
          display: flex;
          align-items: center;
          justify-content: center;
          // float: right;
          float: left;
          text-align: center;
          border: none;
          padding: 0;
          line-height: 24px !important;
          &.yic {
            width: 64px;
            color: #ffa000;
            background: rgba(255, 160, 0, 0.15);
          }
          &.gjr {
            width: 100px;
          }
        }
        .tag1 {
          width: 40px;
          height: 24px;
          background: rgba(48, 191, 120, 0.15);
          border-radius: 2px;
          font-size: 12px;
          font-weight: 400;
          color: #30bf78;
          text-align: center;
          border: none;
          padding: 0;
          line-height: 24px !important;
        }

        .tag2 {
          width: 40px;
          height: 24px;
          background: rgba(255, 160, 0, 0.15);
          border-radius: 2px;
          font-size: 12px;
          font-weight: 400;
          color: #ffa000;
          text-align: center;
          padding: 0;
          line-height: 24px !important;
          border: none;
        }

        .tag3,
        .tagnull {
          width: 40px;
          height: 24px;
          background: none;
          border: 1px solid #bbbeca;
          border-radius: 2px;
          font-size: 12px;
          font-weight: 400;
          color: #555555;
          text-align: center;
          padding: 0;
          line-height: 24px !important;
        }

        .netRecommend {
          float: right;
          //  position: absolute;
          //  right: 14px;
          //  bottom: 16px;
        }
      }
      .box_content_list .active {
        border: 1px solid rgba(80, 122, 251, 1);
        .checked {
          display: block;
          position: absolute;
          top: 0px;
          left: 0px;
          // width: 0;
          // height: 0;
          // border-top: 20px solid rgba(80, 122, 251, 1);
          // border-right: 30px solid transparent;
          // color: #fff;
          // > i {
          //   position: absolute;
          //   top: -20px;
          //   left: 1px;
          // }
        }
      }

      .box_content_list li.pointer:hover {
        border: 1px solid #5088ff;
      }
    }
    .underline {
      text-decoration: underline;
      color: #f59a23 !important;
      font-size: 12px;
    }
    &.erpNumber_box {
      .fixation {
        height: 90px;
      }
      .box_content {
        height: calc(100% - 90px);
        padding-top: 10px;
        .box_content_list {
          li {
            padding: 0;
            .erpGet {
              font-weight: 400;
              color: #5088ff;
              font-size: 13px;
              text-align: center;
              border-top: 1px solid rgba(187, 190, 202, 0.2);
              height: 38px;
              line-height: 38px;
              &.pointerE {
                span {
                  color: #999999;
                  pointer-events: none;
                  cursor: auto;
                }
              }
            }
            .list_inside {
              padding: 25px 16px 16px;
            }
          }
        }
      }
    }
  }
}

.sureFeedBack {
  padding: 0;
  border: 0 !important;
  background-color: royalblue;
  color: #fff;
  cursor: pointer;
  width: 46px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 3px;
  display: inline-block;
  /* margin-left: 20px; */
  position: relative;
  left: 50%;
  /* top: 0px; */
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  &:hover {
    background-color: #4169e1cf;
  }
}
/deep/ .el-drawer__header {
  margin: 0;
  padding: 0;
}
/deep/ .el-scrollbar__wrap {
  scroll-behavior: smooth;
  overflow-x: hidden;
}

// /deep/ .el-drawer__body {
//   overflow-y: auto;
//   overflow-x: hidden;
// }

/*滚动条宽 长,滚动条整体部分，其中的属性有width,height,background,border等。*/

/deep/ .el-drawer__body::-webkit-scrollbar {
  width: 7px;
}

/*滚动条的滑轨背景颜色,可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

/deep/ .el-drawer__body::-webkit-scrollbar-track {
  background-color: transparent;

  // -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.1);

  border-radius: 5px;
}

/* 滑块颜色 */

/deep/ .el-drawer__body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);

  border-radius: 5px;
}

/*滚动条两端的按钮。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果。*/

/deep/ .el-drawer__body::-webkit-scrollbar-button {
  background-color: #eee;

  display: none;
}

/* 横向滚动条和纵向滚动条相交处尖角的颜色 */

/deep/ .el-drawer__body::-webkit-scrollbar-corner {
  background-color: black;
}

/deep/ {
  .el-drawer {
    // background: none;
  }
  .el-drawer__body {
    padding: 0;
  }
}

.phone-fakk {
  display: flex;
  flex-direction: column;
  .check-list-warp {
    padding: 12px 16px;
  }
  /deep/ {
    .el-checkbox__label {
      font-size: 14px;
      color: rgba(38, 38, 38, 1);
    }
    .el-checkbox + .el-checkbox {
      margin-top: 10px;
    }
  }
}
.llll {
  width: 100%;
  height: 32px;
  background: rgba(241, 242, 244, 0.6);
  border-radius: 0px 0px 4px 4px;
  font-size: 14px;
  font-weight: 400;
  color: #666666;
  line-height: 32px;
  position: relative;
  &:hover {
    color: #ffffff;
  }
}
.tag-min {
  &.success {
    background: rgba(48, 191, 120, 0.15);
    color: rgba(48, 191, 120, 1);
  }
  &.info {
    background: #f3f3f5;
    border-radius: 2px;
    border: 1px solid #bbbeca;
    color: rgba(85, 85, 85, 1);
  }
  &.tag4 {
    background: rgba(76, 175, 80, 0.2);
    color: #2e7d32; // 使用深一些的绿色文字，增强对比
  }
  &.tag6 {
    background: rgba(33, 150, 243, 0.15);
    color: #2196f3; // 蓝色文字
  }
}
</style>
<style lang="scss" scoped>
.cls001 {
  &.telCls001 {
    position: relative;
    transition: all 0.3s;
    .telCode {
      display: none;
      position: relative;
      text-align: center;
      opacity: 0;
      // height: 20px;
      background: transparent;
      padding-left: 4px;
      top: -2px;
      i {
        background: #edf3ff;
        font-weight: 400;
        color: #5088ff !important;
        display: block;
        font-size: 12px;
        line-height: 20px;
        border-radius: 2px;
        padding: 0px 2px;
        box-sizing: border-box;
      }
    }
    &:hover {
      .blodd {
        background: rgba(187, 190, 202, 0.3);
        color: #5088ff !important;
        font-size: 16px !important;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal !important;
        padding: 0 2px;
        box-sizing: border-box;
      }
      .telCode {
        opacity: 1;
        display: inline-block;
      }
    }
  }
}
.noAllowClick {
  color: #999999;
  cursor: not-allowed;
  background-image: none !important;
  -webkit-box-shadow: 0px 2px 4px 0px #edeef3;
  box-shadow: 0px 2px 4px 0px #edeef3;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(187, 190, 202, 0.5) !important;
}
.textAline {
  text-align: center;
}
</style>
<style lang="scss">
.popper-sources {
  //  position: relative;
  margin-top: 8px;
  line-height: 0.4;
  padding: 8px 16px;
  box-sizing: border-box;
  &::before {
    content: " ";
    position: absolute;
    display: block;
    // top: -25px;
    // border-top: 8px solid transparent;
    // border-right: 8px solid transparent;
    // border-bottom: 8px solid rgba(255, 255, 255, 0.95);
    // border-left: 8px solid transparent;
    transform: translateY(10px);
    top: -4px;
    width: 9px;
    height: 9px;
    right: 0;
    left: 0;
    margin: auto;
    transform: rotate(45deg);
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
    background: rgba(255, 255, 255, 0.95);
  }
}
</style>
